import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const COLS = [
  { title: "Product", links: [["Meet DOX", "meet-dox"], ["How It Works", "how-it-works"], ["Features", "features"], ["Pricing", "pricing"]] },
  { title: "Company", links: [["Contact", "contact"], ["FAQ", "faq"], ["Testimonials", "testimonials"]] },
];

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="relative border-t border-white/10 bg-ink pt-16 pb-10 overflow-hidden">
      <div className="glow-orb w-[600px] h-[300px] left-1/2 -translate-x-1/2 -bottom-40 bg-dox-purple/15" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo maxWidth={360} />
            <p className="mt-2 text-xs tracking-[0.2em] uppercase text-white/40">Let Dox do it.</p>
            <p className="mt-5 max-w-sm text-white/55 text-sm leading-relaxed">
              EZDoxAI is your AI Compliance Employee. Upload your paperwork once — DOX takes care of the rest.
            </p>
            <button
              data-testid="footer-trial-btn"
              onClick={() => navigate("/signup")}
              className="mt-6 rounded-full bg-dox-orange px-6 py-3 text-sm font-bold text-white hover:bg-dox-orangeHover transition-colors"
            >
              Start Free Trial
            </button>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/70 mb-4">{c.title}</div>
              <ul className="space-y-3">
                {c.links.map(([label, id]) => (
                  <li key={id}>
                    <button onClick={() => scrollToId(id)} className="text-sm text-white/50 hover:text-white transition-colors">
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} EZDoxAI. All rights reserved.</p>
          <p className="text-xs text-white/40">Not legal advice. DOX verifies against official sources where possible.</p>
        </div>
      </div>
    </footer>
  );
}
